import { apiRequest } from './client';
import {
  AdditionalServiceSummary,
  NearbyPartner,
  NearbyPartnersQueryParams,
  StorefrontQueryParams,
  StorefrontService,
} from '../types/additionalServiceTypes';

export async function fetchStorefront(params: StorefrontQueryParams): Promise<StorefrontService[]> {
  const query = new URLSearchParams();
  query.set('latitude', String(params.latitude));
  query.set('longitude', String(params.longitude));
  if (params.radius !== undefined) query.set('radius', String(params.radius));
  return apiRequest<StorefrontService[]>(`additional-services/storefront?${query.toString()}`);
}

export async function fetchNearbyPartners(
  serviceId: number,
  params: NearbyPartnersQueryParams,
): Promise<NearbyPartner[]> {
  const query = new URLSearchParams();
  query.set('latitude', String(params.latitude));
  query.set('longitude', String(params.longitude));
  if (params.radius !== undefined) query.set('radius', String(params.radius));
  return apiRequest<NearbyPartner[]>(
    `additional-services/${serviceId}/nearby-partners?${query.toString()}`,
  );
}

export async function fetchAllServices(): Promise<AdditionalServiceSummary[]> {
  return apiRequest<AdditionalServiceSummary[]>('additional-services');
}
